import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import CTAButton from "../Buttons/CTAButton/CTAButton";
import ContentImage from "../../assets/images/Content Image.png";

const ContentSectionDesktop = () => {
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["start end", "end start"]
  });

  // Transform scroll progress to circle circumference (0 to 1 = 0% to 100% of circle)
  const circleProgress = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <div ref={targetRef}>
      <section className="bg-white dark:bg-gray-900">
        <div className="w-full  bg-Color-White flex flex-col lg:flex-row justify-start items-center gap-2">
          <div className="flex-1 z-10 flex justify-start items-center gap-2 w-full lg:w-auto">
            <img
              className="flex-1 h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[852px] w-full object-cover rounded-br-[150px] sm:rounded-br-[200px] md:rounded-br-[250px] lg:rounded-br-[300px] xl:rounded-br-[358px]"
              src={ContentImage}
              alt="Content"
            />
          </div>
          <div className=" flex-1 self-stretch p-6 sm:p-8 md:p-10 lg:p-12 flex flex-col justify-center items-start gap-2 w-full lg:w-auto">
            <div className="self-stretch pr-4 sm:pr-6 md:pr-8 py-4 relative flex flex-col justify-end items-start gap-6 sm:gap-8 md:gap-10">
              
              {/* Animated Circle Ring */}
              <div className="absolute left-[-100px] sm:left-[-150px] md:left-[-180px] lg:left-[-120px] xl:left-[-230px] top-[-100px] sm:top-[-120px] md:top-[-150px] lg:top-[-124px] xl:top-[-200.50px]">
                <svg 
                  className="w-[400px] h-[400px] sm:w-[500px] sm:h-[500px] md:w-[650px] md:h-[650px] lg:w-[700px] lg:h-[700px] xl:w-[850px] xl:h-[850px]"
                  viewBox="0 0 850 850"
                >
                  {/* Background circle (optional - for reference) */}
                  <circle
                    cx="425"
                    cy="425"
                    r="423"
                    fill="none"
                    stroke="rgba(223, 117, 0, 0.1)"
                    strokeWidth="2"
                    className="hidden lg:block"
                  />
                  
                  {/* Animated circle */}
                  <motion.circle
                    cx="425"
                    cy="425"
                    r="423"
                    fill="none"
                    stroke="#DF7500"
                    strokeWidth="2"
                    className="hidden lg:block"
                    style={{
                      pathLength: circleProgress,
                      rotate: 180, // Start from bottom (6 o'clock position)
                      transformOrigin: "center"
                    }}
                    initial={{ pathLength: 0 }}
                    strokeLinecap="round"
                    strokeDasharray="1 1"
                  />
                </svg>
              </div>

              {/* ...existing code... */}
              <div className="z-20 w-full max-w-[600px] justify-start">
                <span className="text-Color-Black text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-normal font-['Montserrat']">
                  Celebrating a{" "}
                </span>
                <span className="text-Color-Brand text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold font-['Montserrat'] underline">
                  Legacy
                </span>
              </div>
              <div className="z-20 w-full lg:w-[540px] xl:max-w-[600px] justify-start text-Color-Black text-sm sm:text-base md:text-lg font-medium font-['Montserrat'] tracking-tight">
                The Faculty of Engineering, University of Ruhuna, proudly marks
                its 25th Anniversary this year! For a quarter of a century, we
                have been at the forefront of engineering education and research
                in Sri Lanka, nurturing generations of brilliant minds who have
                gone on to shape industries, drive innovation, and contribute
                significantly to national and global development.
              </div>
              <div className="z-20">

                <CTAButton text="READ MORE" url="https://www.eng.ruh.ac.lk/" target="_blank"/>

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContentSectionDesktop;